import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MessageCircle } from 'lucide-react';

const CTASection = () => {
  return (
    <section
      className="ln-cta-section px-4 py-14 sm:px-6 lg:px-8"
      style={{ backgroundColor: '#ffffff' }}
    >
      <div
        className="mx-auto max-w-7xl overflow-hidden rounded-lg px-6 py-10 sm:px-10 lg:px-12"
        style={{
          backgroundColor:
            '#800E13',
          boxShadow: '0 24px 70px rgba(8, 37, 61, 0.18)',
        }}
      >
        <div className="grid gap-8 lg:grid-cols-1">
          <div className="text-center">
            <div
              className="mb-5 inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-bold"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.12)',
                borderColor: 'rgba(255, 255, 255, 0.22)',
                color: '#FFFFFF',
              }}
            >
              <MessageCircle className="h-4 w-4" style={{ color: '#FDBA74' }} />
              Get Started
            </div>

            <h2
              className="mx-auto max-w-3xl text-3xl font-semibold leading-tight sm:text-4xl lg:text-4xl"
              style={{ color: '#FFFFFF' }}
            >
              Ready to optimize your Infor environment?
            </h2>
            <p
              className="mx-auto mt-5 max-w-6xl text-base leading-8  text-center"
              style={{ color: '#FFFFFF', fontWeight: 400 }}
            >
              Talk to a KCS Tech consultant today and discover how we can streamline your operations and drive measurable results.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:flex-row">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                className="inline-flex w-full items-center justify-center gap-3 rounded-lg px-6 py-4 text-base font-bold transition duration-300 hover:-translate-y-1 sm:w-auto"
                style={{
                  backgroundColor: '#FFFFFF',
                  color: '#0B1F32',
                  boxShadow: '0 18px 42px rgba(0, 0, 0, 0.18)',
                }}
              >
                <Calendar className="h-5 w-5" style={{ color: '#800E13' }} />
                Get in Touch
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;